import React from 'react';
import { Redirect, Route } from 'react-router-dom';

import { useUserState } from '../../store/hooks';

const PrivateRoute = ({ component: Component, ...rest }: any) => {
  
  const user = useUserState();
  
  return (
    <Route
      {...rest}
      render={(props) => {
        if (user.isLogged) {
          return <Component {...props} />;
        }
        return (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location, toReturn: props.location.pathname }
            }}
          />
        );
      }}
    />
  );
};

export default PrivateRoute;
